var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { FileInput, FileInputLabel } from '@vp/swan';
import { useUploadConfiguration } from '../UploadConfigurationProvider';
import { useFileUploadHandler } from '../Hooks';
import { useUploadManager } from '../../UploadManagerProvider';
import { useLocalization } from '../../Localization';
import { UploadingAnnouncementKeys } from '../../UploadManagerProvider/UploadManagerProvider';
export const useLocalizedUploadingAnnouncementLabel = () => {
    const { uploadingStartAnnouncement, uploadingFinishedAnnouncement, uploadingErrorAnnouncement } = useLocalization();
    const { uploadingAnnouncement } = useUploadManager();
    return useMemo(() => {
        const labels = {
            [UploadingAnnouncementKeys.UploadingStart]: uploadingStartAnnouncement || 'Uploading started',
            [UploadingAnnouncementKeys.UploadingFinished]: uploadingFinishedAnnouncement || 'Uploading finished',
            [UploadingAnnouncementKeys.UploadingError]: uploadingErrorAnnouncement || 'An error occurred during the upload',
        };
        return uploadingAnnouncement ? labels[uploadingAnnouncement] : '';
    }, [uploadingAnnouncement, uploadingErrorAnnouncement, uploadingFinishedAnnouncement, uploadingStartAnnouncement]);
};
/**
 * Component to facilitate uploads. Processing in done by a passed in callback.
 */
export const UploadsButton = forwardRef((props, ref) => {
    const { supportedFileTypes: { acceptedTypesAsString }, } = useUploadConfiguration();
    const uploadingAnnouncement = useLocalizedUploadingAnnouncementLabel();
    const { children, onBeforeUpload, onUploadStart, onChange, skin, size, width, specialVariant, iconPosition, buttonShape, className, 'data-testid': dataTestId } = props, inputProps = __rest(props, ["children", "onBeforeUpload", "onUploadStart", "onChange", "skin", "size", "width", "specialVariant", "iconPosition", "buttonShape", "className", 'data-testid']);
    const { handleChange, fileInputRef } = useFileUploadHandler({
        onUploadStart,
        onBeforeUpload,
        onChange,
        ref,
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ role: "status", "aria-live": "polite", className: "swan-visually-hidden" }, { children: uploadingAnnouncement })), _jsx(FileInput, Object.assign({ accept: acceptedTypesAsString, onChange: handleChange, ref: fileInputRef }, inputProps, { children: _jsx(FileInputLabel, Object.assign({ skin: skin, size: size, width: width, specialVariant: specialVariant, iconPosition: iconPosition, buttonShape: buttonShape, className: className, "data-testid": dataTestId }, { children: children })) }))] }));
});
UploadsButton.displayName = 'UploadsButton';
//# sourceMappingURL=UploadsButton.js.map